// import './common/events/clickToScroll';
const requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame;

const cancelAnimationFrame =
  window.cancelAnimationFrame || window.mozCancelAnimationFrame;


customElements.define('product-description-component', class productDescription extends HTMLElement{
	constructor(){
		super();

		this.addEventListener('click', (e)=>{
			const {target} = e;
			if(!target.closest('.js-scroll-to')) return;

			e.preventDefault();

			// this.querySelector(target.dataset.scroll).scrollIntoView({ behavior: "smooth", block: "start" });

			this.scrollTo2(target.dataset.scroll)

		})
	}

	connectedCallback(){
		this.addEventListener('click', (e)=>{
			const {target} = e;
			target.closest('.tab-links')?.querySelectorAll('a').forEach(i=>{
				i.classList.toggle('active', i == target.closest('a'));
			})
		})
	}

	scrollTo(selector){
        document.querySelector(selector).scrollIntoView({
            behavior: 'smooth'
        });

	}

	scrollTo2(selector){
		// const step = 23.33;
		
	const yOffset = -100; 
	const target = this.querySelector(selector);
	const y = target.getBoundingClientRect().top + window.scrollY  + yOffset;

	window.scrollTo({top: y, behavior: 'smooth'});
	
		console.log('target',target)
	

	}

});